import { cn } from '@/lib/utils'

// Bloco de carregamento com shimmer. Dá percepção de velocidade no lugar do
// texto "Carregando…".
function Skeleton({ className, ...props }: React.ComponentProps<'div'>) {
  return <div data-slot="skeleton" className={cn('bg-muted animate-pulse rounded-md', className)} {...props} />
}

// Esqueleto de tabela: N linhas com células cinza. `cols` controla a largura das
// colunas (fração), `rows` a quantidade de linhas.
function TableSkeleton({ rows = 6, cols = 4 }: { rows?: number; cols?: number }) {
  return (
    <div className="divide-border divide-y" aria-hidden>
      {Array.from({ length: rows }).map((_, r) => (
        <div key={r} className="flex items-center gap-4 px-4 py-3">
          {Array.from({ length: cols }).map((_, c) => (
            <Skeleton key={c} className={cn('h-4', c === 0 ? 'w-1/3' : 'flex-1')} />
          ))}
        </div>
      ))}
    </div>
  )
}

export { Skeleton, TableSkeleton }
